/*
  Header logo on scroll, in four steps (Marcus's top bar delivery, 2026-10-31):
    scrolling away from the top   1. wordmark disappears  wipe, 1200 ms
                                  2. monogram appears     draw, 2100 ms
    back at the top               3. monogram disappears  draw, 1600 ms
                                  4. wordmark appears     wipe, 1400 ms
  The steps run one after the other. Ported from his four comps (wordmark-disappears.aep,
  monogram-appears.aep, monogram-disappears.aep, wordmark-appears.aep, the comps marked
  "USE THIS IN THE TOP BAR"):
  - Wordmark: After Effects Linear Wipe, angle 270 (the edge travels right to left, so the
    wordmark is erased from its end and written back from its start), feather 24 in a 434
    wide comp, i.e. 24/434 of the wordmark's width. Done here with a CSS mask.
  - Monogram: the C and B pens as before, B 0-2.1 s and C 0.6-2.1 s in, B 1.6 s and C
    1.1 s out, each span of a pen's travel on its own path (data-from / data-to).
  - Every step uses his "steady pace, soft landing" expression with the Controls values
    (Ease in 12.857 %, Landing 55.387 %, Landing tail 30 %); going out is the mirrored
    curve, as his expression does for a falling slider.
  The whole sequence plays SPEED times faster (Alexander 2026-10-30: "a little faster").

  ONE GESTURE. The swap rides the theme's header--scrolled class (on past 25px, off at the
  top), so the white ground and the first step start in the same frame. A change of mind
  mid-way runs the other direction from wherever the logo is, each step shortened in
  proportion to what is left of it.
*/
(function () {
  var SPEED = 1.5;
  var WIPE_OUT = 1.2 / SPEED, WIPE_IN = 1.4 / SPEED, FEATHER = 24 / 434;
  var LETTERS = {
    B: { start: 0, end: 2.1 / SPEED, out: 1.6 / SPEED },
    C: { start: 0.6 / SPEED, end: 2.1 / SPEED, out: 1.1 / SPEED }
  };

  var a = 0.12857, d = Math.min(0.55387, 1 - a), p = 1 - 0.3, b = 1 - d;
  function R(w) { return (1 + Math.cos(Math.PI * Math.pow(w, p))) / 2; }
  function I(u) {
    var n = 64, h = u / n, sum = R(0) + R(u);
    for (var k = 1; k < n; k++) sum += R(k * h) * (k % 2 ? 4 : 2);
    return sum * h / 3;
  }
  var V = 1 / (a / 2 + (b - a) + d * I(1));
  function ease(x) {
    if (x <= a) return V * (x / 2 - a / (2 * Math.PI) * Math.sin(Math.PI * x / a));
    if (x <= b) return V * (a / 2 + (x - a));
    return V * (a / 2 + (b - a) + d * I(Math.min(1, (x - b) / d)));
  }
  function clamp(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }

  var header = document.getElementById('header');
  var paths = header ? header.querySelectorAll('.brand-monogram path') : [];
  var marks = header ? header.querySelectorAll('.header-logo .logo') : [];
  if (!paths.length) return;
  var DASH = 2000, lengths = [];
  for (var n = 0; n < paths.length; n++) lengths.push(paths[n].getTotalLength());
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  // wordmark: 1 = whole, 0 = wiped away. drawn: share of each pen's travel on screen.
  var wordmark = 1, drawn = { B: 0, C: 0 };
  var fromW = 1, from = { B: 0, C: 0 };
  var showing = false, t0 = 0, raf = 0;

  function paintWordmark() {
    for (var i = 0; i < marks.length; i++) {
      var el = marks[i], mask = '';
      if (wordmark < 1) {
        // The edge runs from just past the right end (whole) to just before the left
        // (gone), so the feather never clips a letter at either end.
        var w = el.getBoundingClientRect().width, f = w * FEATHER;
        var edge = wordmark * (w + f) - f / 2;
        mask = 'linear-gradient(90deg, #000 ' + (edge - f / 2).toFixed(2) + 'px, transparent ' + (edge + f / 2).toFixed(2) + 'px)';
      }
      el.style.webkitMaskImage = mask;
      el.style.maskImage = mask;
    }
  }

  function paintMonogram() {
    for (var i = 0; i < paths.length; i++) {
      var el = paths[i], f = drawn[el.dataset.letter] * 100;
      var lo = +el.dataset.from, hi = +el.dataset.to;
      // dash and gap are DASH user units each (longer than any segment), so the visible
      // part is DASH - offset. Real lengths, not pathLength: Chrome mis-draws pathLength
      // dashes on high-density phone screens.
      el.style.strokeDashoffset = DASH - clamp((f - lo) / (hi - lo)) * lengths[i];
    }
  }

  function frame(now) {
    var t = (now - t0) / 1000, done, L, k, s;
    if (showing) {
      // 1. wordmark out, for what is left of it; 2. monogram in once it is gone.
      var wipe = WIPE_OUT * fromW;
      wordmark = fromW * (1 - ease(clamp(wipe ? t / wipe : 1)));
      done = t >= wipe;
      for (L in LETTERS) {
        k = LETTERS[L];
        s = clamp((t - wipe - k.start * (1 - from[L])) / ((k.end - k.start) * (1 - from[L]) || 1e-6));
        drawn[L] = from[L] + (1 - from[L]) * ease(s);
        if (s < 1) done = false;
      }
    } else {
      // 3. monogram out, for what is drawn of it; 4. wordmark in once it is gone.
      var out = 0;
      for (L in LETTERS) {
        k = LETTERS[L];
        var len = k.out * from[L];
        s = clamp(len ? t / len : 1);
        drawn[L] = from[L] * (1 - ease(s));
        out = Math.max(out, len);
      }
      s = clamp((t - out) / (WIPE_IN * (1 - fromW) || 1e-6));
      wordmark = fromW + (1 - fromW) * ease(s);
      done = s >= 1;
    }
    paintWordmark();
    paintMonogram();
    raf = done ? 0 : requestAnimationFrame(frame);
  }

  function go(show) {
    if (show === showing) return;
    showing = show;
    header.classList.toggle('is-monogram', show);
    fromW = wordmark; from.B = drawn.B; from.C = drawn.C;
    cancelAnimationFrame(raf);
    if (reduced.matches) {
      wordmark = show ? 0 : 1;
      drawn.B = drawn.C = show ? 1 : 0;
      paintWordmark();
      paintMonogram();
      return;
    }
    t0 = performance.now();
    raf = requestAnimationFrame(frame);
  }

  function sync() { go(header.classList.contains('header--scrolled')); }
  new MutationObserver(sync).observe(header, { attributes: true, attributeFilter: ['class'] });
  sync();
})();
